import { useEffect, useState } from "react"
import { AnimatePresence } from "framer-motion"
import { DashboardContainer, Header, Title, ContentArea } from "../components/Dash/styled/Layout"
import { NavTabs, NavTab, TabContent } from "../components/Dash/styled/Navigation"
import { ProductTable } from "../components/Dash/ProductTable"
import { OrdersTable } from "../components/Dash/OrdersTable"
import Modal from "../components/Modal"
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from "react-router-dom"
import { useProductos } from "../hooks/useProductos"
import { useSnackbar } from "notistack"
import { Toaster } from "react-hot-toast"
import { InventoryTable } from "../components/Dash/InventoryTable"
import { AnalyticsPanel } from "../components/AnalyticsPanel"
import {ScooterTable} from "../components/Dash/ScooterTable"
import { API } from "../components/FormEdit"
import toast from "react-hot-toast"
import { WebEditor } from "../components/WebEditor"

export default function Dashboard() {
  const [activeTab, setActiveTab] = useState("products")
  const [editingProduct, setEditingProduct] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [inventory, setInventory] = useState([])
  const { formatoCOP, ordenes, getOrdenes, deleteProducto } = useProductos();
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);

  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    fetch(`${API}/api/productos/productos`)
    .then(data => data.json())
    .then(data => setProducts(data.productos))

    fetch(`${API}/api/inventory`)
    .then(data => data.json())
    .then(data => {
      console.log(data)
      setInventory(data.inventarios)
    })
    .catch(e => console.log(e))

    getOrdenes();
  }, []);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.5,
        when: "beforeChildren",
      },
    },
  }

  const headerVariants = {
    hidden: { y: -50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 100,
      },
    },
  }

  const handleAddProduct = () => {
    const newProduct = {
      id: (products.length + 1).toString(),
      name: "Nuevo Producto",
      sku: `SKU-${products.length + 1}`,
      inventory: 0,
      price: 0,
      category: "Sin categoría",
      colors: ["#000000"],
      date: new Date().toISOString().split("T")[0],
    }
    setProducts([...products, newProduct])
  }


  const handleDeleteProduct = (productId) => {
    setProducts(products.filter((product) => product.id !== productId));

    deleteProducto(productId).then((data) => {
      enqueueSnackbar('Producto eliminado con exito.', { variant: 'success', anchorOrigin: { vertical: 'bottom', horizontal: 'right' } });
    }).catch((error) => {
      console.log(error);
    })

  }

  const openEditModal = (product) => {
    setEditingProduct(product)
  }


    
  const handleAddInventory =  async (newItem) => {
    const pet = await fetch(`${API}/api/inventory`, {
      method: "POST",
      body: JSON.stringify(newItem),
      headers: {
        "Content-Type": "application/json"
      }
    })
    const data = await pet.json()
    console.log(data)
    if (data.error) return toast.error(data.error)
    toast.success("Inventario agregado con éxito")
    setInventory(data.inventarios)
  }

  const handleEditInventory = async (editedItem) => {
    const pet = await fetch(`${API}/api/inventory/${editedItem.id}`, {
      method: "PUT",
      body: JSON.stringify(editedItem),
      headers: {
        "Content-Type": "application/json"
      }
    })
    const data = await pet.json()
    console.log(data)
    if (data.error) return toast.error(data.error)
    toast.success("Inventario actualizado con éxito")
    setInventory(data.inventarios)
  }

  const handleDeleteInventory = async (itemId) => {
    const pet = await fetch(`${API}/api/inventory/${itemId}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json"
      }
    })
    const data = await pet.json()
    console.log(data)
    if (data.error) return toast.error(data.error)
    toast.success("Inventario eliminado con éxito")
    setInventory(data.inventarios)
  }

  return (
    <DashboardContainer initial="hidden" animate="visible" variants={containerVariants}>
      <Toaster />
      <Header variants={headerVariants}>
        <Title>Administración</Title>

        <LogoutIcon style={{ cursor: "pointer" }} onClick={() => navigate("/")} />

      </Header>
      <ContentArea>
        <NavTabs>
          <NavTab
            isActive={activeTab === "products"}
            onClick={() => setActiveTab("products")}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Bicicletas
          </NavTab>
          <NavTab
            isActive={activeTab === "scooters"}
            onClick={() => setActiveTab("scooters")}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Scooters
          </NavTab>
          <NavTab
            isActive={activeTab === "orders"}
            onClick={() => setActiveTab("orders")}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Pedidos
          </NavTab>

          <NavTab
            isActive={activeTab === "inventory"}
            onClick={() => setActiveTab("inventory")}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Inventario
          </NavTab>

          <NavTab
            isActive={activeTab === "web-editor"}
            onClick={() => setActiveTab("web-editor")}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Editar Web
          </NavTab>

          <NavTab
            isActive={activeTab === "analytics"}
            onClick={() => setActiveTab("analytics")}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Analíticas
          </NavTab>

        </NavTabs>

        <AnimatePresence mode="wait">
          {activeTab === "products" && (
            <TabContent
              key="products"
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -20 }}
              transition={{ type: "spring", stiffness: 100 }}
            >
              <ProductTable
                products={products}
                onAddProduct={handleAddProduct}
                onEditProduct={openEditModal}
                onDeleteProduct={handleDeleteProduct}
              />
            </TabContent>
          )}

            {activeTab === "scooters" && (
            <TabContent
              key="scooters"
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -20 }}
              transition={{ type: "spring", stiffness: 100 }}
            >
              <ScooterTable
                products={products.filter(p => p.isScooter)}
              />
            </TabContent>
          )}



          {activeTab === "orders" && (
            <TabContent
              key="orders"
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -20 }}
              transition={{ type: "spring", stiffness: 100 }}
            >
              <OrdersTable orders={ordenes} />
            </TabContent>
          )}

          {activeTab === "inventory" && (
            <TabContent
              key="inventory"
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -20 }}
              transition={{ type: "spring", stiffness: 100 }}
            >
              <InventoryTable inventory={inventory} products={products} onAddInventory={handleAddInventory} onEditInventory={handleEditInventory} onDeleteInventory={handleDeleteInventory} />
            </TabContent>
          )}

          {activeTab === "web-editor" && (
            <TabContent
              key="web-editor"
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -20 }}
              transition={{ type: "spring", stiffness: 100 }}
            >
              <WebEditor products={products} />
            </TabContent>
          )}

          {activeTab === "analytics" && (
            <TabContent
              key="analytics"
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -20 }}
              transition={{ type: "spring", stiffness: 100 }}
            >
              <AnalyticsPanel />
            </TabContent>
          )}


        </AnimatePresence>
      </ContentArea>

      {isModalOpen &&
        <Modal
          onClose={() => setIsModalOpen(false)}
        />}

    </DashboardContainer>

  )
}


